module.exports = __webpack_public_path__ + "static/media/3.Sad Face 1.99334691.gif";